import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';
import {
  MARKET_SCAN_COMPARE_ROUTE,
  MARKET_SCAN_SELECTION_ROUTE,
  MARKET_SCAN_PURCHASE_ROUTE,
  MARKET_SCAN_RESULTS_ROUTE,
  MARKET_SCAN_RESULTS_LIFE_ROUTE,
  POLICY_DETAILS_ROUTE,
  MARKET_SCAN_STATUS_ROUTE,
  MARKET_SCAN_NEW_ROUTE,
  MARKET_SCAN_ROUTE,
  HOME_ROUTE,
  DASHBOARD_ROUTE,
  EXPLORE_ROUTE,
  NOTIFICATIONS_ROUTE,
} from 'constants/routes';
import { getMarketScanNewRouteByName } from 'helpers';
import { IQuote } from 'types';

const CUSTOM_NAV_ROUTES = [POLICY_DETAILS_ROUTE.replace('/:id', '')];

const HIDE_NAV_ROUTES = [
  getMarketScanNewRouteByName(INSURANCE_TYPES_NAMES.VEHICLE),
  getMarketScanNewRouteByName(INSURANCE_TYPES_NAMES.CONTENT),
  getMarketScanNewRouteByName(INSURANCE_TYPES_NAMES.HOME),
  getMarketScanNewRouteByName(INSURANCE_TYPES_NAMES.MOTORCYCLE),
  getMarketScanNewRouteByName(INSURANCE_TYPES_NAMES.LIFE),
  MARKET_SCAN_COMPARE_ROUTE,
  MARKET_SCAN_SELECTION_ROUTE.replace('/:policyTypeName', ''),
  MARKET_SCAN_PURCHASE_ROUTE,
  MARKET_SCAN_RESULTS_ROUTE,
];

export const isMobileNavRoute = (pathname: string) => {
  return !HIDE_NAV_ROUTES.some((route) => pathname.includes(route));
};

export const shouldShowMobileNav = (pathname: string) => {
  return ![...HIDE_NAV_ROUTES, ...CUSTOM_NAV_ROUTES].some((route) =>
    pathname.startsWith(route),
  );
};

export const shouldReducePadding = (pathname: string) => {
  return [MARKET_SCAN_RESULTS_ROUTE].includes(pathname);
};

export const isMarketScanIndexPage = (pathname: string) => {
  return pathname === MARKET_SCAN_ROUTE;
};

const NAVBAR_PAGE_TITLE_ROUTES = [
  HOME_ROUTE,
  DASHBOARD_ROUTE,
  MARKET_SCAN_ROUTE,
  EXPLORE_ROUTE,
  NOTIFICATIONS_ROUTE,
];

export const hasNavbarPageTitle = (pathname: string) => {
  return NAVBAR_PAGE_TITLE_ROUTES.includes(pathname);
};

export const isMarketScanWaitingPage = (pathname: string) => {
  return pathname === MARKET_SCAN_STATUS_ROUTE;
};

export const isMarketScanResultsPage = (pathname: string) => {
  return pathname === MARKET_SCAN_RESULTS_ROUTE;
};

// Results page: on desktop it gets the exit bar and no sidebar, including
// while the scan is still loading. Life has its own results route and keeps
// the collapsed sidebar.
export const hasMarketScanExitBar = (
  pathname: string,
  policyScan?: { policyType?: string },
) =>
  isMarketScanResultsPage(pathname) &&
  policyScan?.policyType !== INSURANCE_TYPES_NAMES.LIFE;

export const isMarketScanResultsLifePage = (pathname: string) => {
  return pathname.includes(MARKET_SCAN_RESULTS_LIFE_ROUTE);
};

export const isNewMarketScanLifePage = (pathname: string) => {
  const lifeRoute = MARKET_SCAN_NEW_ROUTE.replace(':policyTypeName?', 'Life');
  return pathname === lifeRoute;
};

export const showMSStatusHeader = (pathname: string) =>
  isMarketScanWaitingPage(pathname) ||
  isMarketScanResultsPage(pathname) ||
  pathname.includes(MARKET_SCAN_RESULTS_LIFE_ROUTE);

export const isMSResults = (pathname: string) =>
  isMarketScanResultsPage(pathname) || isMarketScanResultsLifePage(pathname);

export const isPartnersLife = (quote: IQuote) =>
  quote.policyProviderName === 'Partners Life';

export const isPinnacleLife = (quote: IQuote) =>
  quote.policyProviderName === 'Pinnacle Life';

export const getLayoutConditions = (
  pathname: string,
  expanded: boolean,
  showMSWaitingPageHeader: boolean,
  isZoomWorking: boolean,
) => {
  const isLifeResultsPage = isMarketScanResultsLifePage(pathname);
  const isResultsPage = isMarketScanResultsPage(pathname);

  return {
    expanded,
    shouldReducePadding: shouldReducePadding(pathname),
    showMSWaitingPageHeader,
    isLifeResultsPage,
    isLifeResultsPageWithZoom: isLifeResultsPage && isZoomWorking,
    isResultsPageWithZoom: isResultsPage && isZoomWorking,
    hasNavbarPageTitle: hasNavbarPageTitle(pathname),
  };
};
